import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Luk menuen ved sideskift
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const menuItems = [
    { label: 'Forside', href: '/' },
    { label: 'Stiklinger', href: '/stiklinger' },
    { label: 'Bestil knolde', href: '/bestil-knolde' },
    { label: 'Bordpynt & Dekorationer', href: '/ideer-til-bordpynt-og-dekorationer' },
    { label: 'Arrangementer', href: '/arrangementer' },
    { label: 'Om os', href: '/om-os' },
    { label: 'Galleri', href: '/galleri' },
    { label: 'Kontakt', href: '/kontakt' },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const handleBestilClick = (e) => {
    if (location.pathname === '/bestil-knolde') {
      e.preventDefault();
      document.getElementById('bestillingsformular')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsOpen(false);
    }
  };

  return (
    <header
      className="sticky top-0 left-0 right-0 z-50 transition-all duration-300 py-6 border-b bg-white border-cream-200 shadow-md"
    >
      <div className="max-w-7xl mx-auto px-8 flex flex-col min-[1200px]:items-center gap-6">
        {/* Top bar on mobile, centered logo on desktop */}
        <div className="w-full flex items-center justify-between min-[1200px]:justify-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group text-center">
            <img 
              src="https://assets.auxodev.dk/assets/c347dbd5-ff95-4119-bc58-7c327c410cd6/imgi-1-logo2.svg" 
              alt="Dahliahjørnet" 
              className="h-11 sm:h-16 md:h-20 w-auto object-contain"
            />
          </Link>

          {/* Burger Button (Viser under 1200px) */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="min-[1200px]:hidden text-forest-950 hover:text-dahlia-600 focus:outline-none transition-colors"
            aria-label="Menu"
          >
            <i className={`fa-solid ${isOpen ? 'fa-xmark' : 'fa-bars'} text-2xl`} />
          </button>
        </div>

        {/* Desktop Navigation (Burgermenu må først vises under 1200px) */}
        <nav className="hidden min-[1200px]:flex items-center justify-center gap-2 w-full border-t border-forest-900/10 pt-5">
          {menuItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`px-3.5 py-1.5 text-sm font-medium transition-all duration-200 ${
                isActive(item.href)
                  ? 'text-black font-bold'
                  : 'text-charcoal-700 hover:text-black'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/bestil-knolde"
            onClick={handleBestilClick}
            className="ml-4 bg-dahlia-500 hover:bg-dahlia-600 text-white px-4 py-1.5 rounded-full text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex items-center gap-2"
          >
            <i className="fa-solid fa-cart-shopping" />
            Bestil nu
          </Link>
        </nav>
      </div>

      {/* Mobile Navigation (Under 1200px) */}
      <div
        className={`min-[1200px]:hidden absolute inset-x-0 top-full bg-white border-b border-cream-200 shadow-xl transition-all duration-300 ease-in-out ${
          isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10 pointer-events-none'
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-2 max-h-[calc(100vh-80px)] overflow-y-auto">
          {menuItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`px-4 py-2.5 text-base font-medium transition-all ${
                isActive(item.href)
                  ? 'text-black font-bold'
                  : 'text-charcoal-700 hover:text-black'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/bestil-knolde"
            onClick={handleBestilClick}
            className="mt-4 bg-dahlia-500 hover:bg-dahlia-600 text-white py-3 rounded-full text-center font-semibold shadow-md flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-cart-shopping" />
            Bestil knolde her
          </Link>
        </div>
      </div>
    </header>
  );
}
